import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const ExecutiveReviewTab = () => {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["admin-exec"], queryFn: async () => (await api.get("/admin/executive/sessions")).data });
  const toggle = async (id, approved) => {
    try {
      await api.patch(`/admin/executive/sessions/${id}`, { approved });
      qc.invalidateQueries({ queryKey: ["admin-exec"] });
      qc.invalidateQueries({ queryKey: ["executive"] });
      toast.success(approved ? "Session approved" : "Session set back to draft");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <div>
      <p className="max-w-2xl text-sm text-muted-foreground">Executive Briefing sessions are drafted for subject-matter review. Learners see a “Draft” badge until you approve a session.</p>
      <div data-testid="admin-exec-table" className="mt-6 border border-border bg-card">
        {data.map((s) => (
          <div key={s.id} data-testid={`admin-exec-row-${s.id}`} className="flex flex-wrap items-center gap-4 border-b border-border p-4">
            <span className="font-mono text-xs text-muted-foreground">{s.id}</span>
            <Link to={`/executive/sessions/${s.id}`} className="flex-1 font-semibold hover:text-brand-primary">{s.title}</Link>
            <span className="text-xs text-muted-foreground">{s.approved ? (s.approved_by ? `Approved by ${s.approved_by}` : "Published") : "Draft"}</span>
            <Switch data-testid={`admin-exec-approve-${s.id}`} checked={s.approved} onCheckedChange={(c) => toggle(s.id, c)} />
          </div>
        ))}
      </div>
    </div>
  );
};
